import { FilterOption } from './FilterTypes';

export const imageContentTypes: FilterOption[] = [
    {
        label: 'All',
        value: 'all-images',
        urlId: 'all-images',
    },
    {
        label: 'Photos',
        value: 'Photos',
        urlId: 'Photos',
    },
    {
        label: 'Snapshots',
        value: 'Snapshots',
        tooltip: 'Images exclusively sourced from our 4K footage library.',
        urlId: 'Snapshots',
    },
    {
        label: 'Vectors',
        value: 'Vectors',
        urlId: 'Vectors',
    },
    {
        label: 'Illustrations',
        value: 'Illustrations',
        urlId: 'Illustrations',
    },
];

export const fileTypes: FilterOption[] = [
    {
        label: 'Has Transparency',
        value: 'hasTransparency',
        urlId: 'hasTransparency',
    },
];

export const imageMediaDetails: FilterOption[] = [
    {
        label: 'Model Released',
        value: 'talentReleased',
        urlId: 'talentReleased',
    },
    {
        label: 'Property Released',
        value: 'propertyReleased',
        urlId: 'propertyReleased',
    },
];

export const orientations: FilterOption[] = [
    {
        label: 'All',
        value: 'All',
        urlId: 'All',
    },
    {
        label: 'Landscape',
        value: 'Landscape',
        urlId: 'Landscape',
    },
    {
        label: 'Portrait',
        value: 'Portrait',
        urlId: 'Portrait',
    },
    {
        label: 'Square',
        value: 'Square',
        urlId: 'Square',
    },
];

export const usageRights: FilterOption[] = [
    { label: 'All usage rights', value: 'all', urlId: 'all' },
    { label: 'Commercial', value: 'commercial', urlId: 'commercial' },
    { label: 'Editorial', value: 'editorial', urlId: 'editorial' },
];

export const imageCategories: FilterOption[] = [
    {
        label: 'All',
        value: '',
        urlId: 'all',
    },
    {
        label: 'Design Elements',
        value: '2',
        urlId: 'design-elements',
    },
    {
        label: 'Objects',
        value: '3',
        urlId: 'objects',
    },
    {
        label: 'Business',
        value: '4',
        urlId: 'business',
    },
    {
        label: 'People',
        value: '6',
        urlId: 'people',
    },
    {
        label: 'Holidays and Celebrations',
        value: '7',
        urlId: 'holidays-and-celebrations',
    },
    {
        label: 'Nature and Wildlife',
        value: '8',
        urlId: 'nature-and-wildlife',
    },
    {
        label: 'Buildings and Landmarks',
        value: '11',
        urlId: 'buildings-and-landmarks',
    },
    {
        label: 'Sports and Outdoors',
        value: '12',
        urlId: 'sports-and-outdoors',
    },
    {
        label: 'Fictional',
        value: '13',
        urlId: 'fictional',
    },
    {
        label: 'Travel and Transportation',
        value: '14',
        urlId: 'travel-and-transportation',
    },
    {
        label: 'Health and Science',
        value: '15',
        urlId: 'health-and-science',
    },
    {
        label: 'Backgrounds',
        value: '16',
        urlId: 'backgrounds',
    },
    {
        label: 'Cultural',
        value: '17',
        urlId: 'cultural',
    },
    {
        label: 'Beauty and Fashion',
        value: '18',
        urlId: 'beauty-and-fashion',
    },
].sort((a, b) => a.label.localeCompare(b.label));
